import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "children", "active", "hideCloseContentIcon"];
import React from 'react';
import { Menu } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import { ChildrenPropType } from '../../../../../../services/proptypes';
import { classNames } from '../../../../../../utils/classname';
import useSemanticUiProps from '../../../../hooks/use-semantic-ui-props';
import HideContentIcon from '../HideContentIcon';
import './MenuItem.css';
var defaultProps = {
  className: '',
  children: null,
  hideCloseContentIcon: false
};
export default function MenuItem(_ref) {
  var _classNames;
  var className = _ref.className,
    children = _ref.children,
    active = _ref.active,
    hideCloseContentIcon = _ref.hideCloseContentIcon,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (_isEmpty(children)) {
    return null;
  }
  var _useSemanticUiProps = useSemanticUiProps(),
    getMenuItemProps = _useSemanticUiProps.getMenuItemProps;
  var finalClassName = classNames((_classNames = {
    'menu-item': true
  }, _defineProperty(_classNames, className, true), _defineProperty(_classNames, "clickable", true), _classNames));
  var restProps = getMenuItemProps(rest);
  return /*#__PURE__*/React.createElement(Menu.Item, _extends({
    className: finalClassName
  }, restProps, {
    active: active
  }), /*#__PURE__*/React.createElement(React.Fragment, null, children, !hideCloseContentIcon && active && /*#__PURE__*/React.createElement(HideContentIcon, null)));
}
MenuItem.defaultProps = defaultProps;